<mat-card class="default has-progress-bar">
  <mat-progress-bar [mode]="loading ? 'indeterminate' : 'determinate'"></mat-progress-bar>

  <mat-card-title fxLayout="row" fxLayoutAlign="space-between center">
    <span>{{ 'shopper-estimates-dashboard.editor.insurance.title' | translate }}</span>

    @if (primaryInsurance) {
      <button mat-stroked-button color="warn" (click)="onRemoveInsurance()">
        <mat-icon>delete</mat-icon>
        {{ 'common.remove' | translate }}
      </button>
    }
  </mat-card-title>

  <mat-card-content class="p-0">
    @if (primaryInsurance && loading) {
      <div class="py-4 text-muted text-sm text-center p-5">
        {{ 'common.loading' | translate }}
      </div>
    }

    @if (primaryInsurance && eligibility) {
      <mmx-eligibility-card
        class="mt-3"
        [eligibility]="eligibility"
        [insuranceType]="'P'"
        [disabled]="true"
      ></mmx-eligibility-card>
    }

    @if (!primaryInsurance) {
      <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="1rem" class="py-4">
        <span class="text-muted">{{ 'shopper-estimates-dashboard.editor.insurance.no-insurance' | translate }}</span>
        <button mat-stroked-button (click)="onAddInsurance()">
          <mat-icon>add</mat-icon>
          {{ 'shopper-estimates-dashboard.editor.insurance.add-insurance' | translate }}
        </button>
      </div>
    }
  </mat-card-content>
</mat-card>
